import React from "react";
import styles from "./Button.module.scss";
import cx from "classnames";
import WhiteSpinnerLoader from "../Loader/WhiteSpinnerLoader";

interface ButtonProps {
  onClick: () => void;
  text: string;
  type?: "primary" | "secondary" | "default" | "disabled" | "error" | "expired";
  classNames?: string;
  isLoader?: boolean;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  text,
  type = "primary",
  classNames,
  isLoader = false,
  disabled = false,
}) => {
  let buttonClass = styles.button_default;

  if (type === "primary") {
    buttonClass = styles.button_submit;
  } else if (type === "secondary") {
    buttonClass = styles.button_cancel;
  } else if (type === "disabled") {
    buttonClass = styles.button_disabled;
  } else if (type === "error") {
    buttonClass = styles.button_error;
  } else if (type === "expired") {
    buttonClass = styles.button_expired;
  }

  const buttonClick = () => {
    if (!isLoader && !disabled) {
      onClick();
    }
  }

  return (
    <button
      onClick={buttonClick}
      className={`${cx(styles.button, buttonClass, classNames)}`}
      disabled={disabled}
    >
      {isLoader && <WhiteSpinnerLoader />}
      {!isLoader && <p>{text}</p>}
    </button>
  );
};

export default Button;
